const MAP_CONTROLS: Array<[string, string]> = [
  ['Pan', 'Drag anywhere the route line isn’t'],
  ['Zoom', 'Scroll, pinch, or the + / − buttons'],
  ['Rotate & tilt', 'Right-drag, or ⌃-drag'],
  ['Reset north', 'Press the compass, or Shift+↑'],
];

const EDITING: Array<[string, string]> = [
  ['Extend the route', 'Click the map — the new point joins the end'],
  ['Change the road it takes', 'Drag the blue line onto the road you want'],
  ['Move a point', 'Drag its circle'],
  ['Delete a point', 'Click it, then Delete — or × in the list'],
  ['Reorder', 'Drag the rows in the list above'],
  ['Undo / redo', '⌘Z / ⇧⌘Z'],
];

export function HelpPanel() {
  // Collapsed until asked for. <details> keeps its own open state, so there is
  // nothing here for React to hold.
  return (
    <details className="help">
      <summary>How to use this</summary>

      <div className="help-body">
        <h4>Getting the route you want</h4>
        <dl>
          {EDITING.map(([term, description]) => (
            <div key={term}>
              <dt>{term}</dt>
              <dd>{description}</dd>
            </div>
          ))}
        </dl>

        <p className="help-note">
          Dragging the line adds a <strong>shaping point</strong> (a small grey circle) exactly where
          you dropped it. Those only steer the route — they don’t appear as stops when you’re driving.
          Use as many as it takes to pin down a road.
        </p>

        <h4>Moving around the map</h4>
        <dl>
          {MAP_CONTROLS.map(([term, description]) => (
            <div key={term}>
              <dt>{term}</dt>
              <dd>{description}</dd>
            </div>
          ))}
        </dl>

        <h4>Stops vs shaping points</h4>
        <p className="help-note">
          <strong>◉ Stop</strong> — somewhere you actually pull in. Splits the route into legs and
          shows in the itinerary on the phone.
          <br />
          <strong>○ Shaping point</strong> — only there to hold the route on a particular road.
          Invisible while driving. Toggle between them with the circle button on each row.
        </p>
      </div>
    </details>
  );
}
